<form class="password-dialog" [formGroup]="passwordForm" (ngSubmit)="submit()">
	<header class="dialog-header">
		<div class="header-icon" aria-hidden="true"><mat-icon>vpn_key</mat-icon></div>
		<div>
			<h2>Change User Password</h2>
			<p>Set a secure password for this account.</p>
		</div>
	</header>

	<mat-dialog-content class="dialog-content">
		<section class="user-summary" aria-label="Selected user">
			<div class="user-avatar" aria-hidden="true">{{ userInitial }}</div>
			<div class="user-identity">
				<strong>{{ data.name || 'Name not available' }}</strong>
				<span>{{ data.email || 'Email not available' }}</span>
			</div>
		</section>

		<div class="input-box">
			<label for="adminPassword">New password <span>*</span></label>
			<div class="password-input">
				<input
					#passwordInput
					id="adminPassword"
					[type]="passwordType"
					formControlName="password"
					autocomplete="new-password"
					aria-describedby="adminPasswordHint"
				/>
				<button
					type="button"
					mat-icon-button
					(click)="toggleVisibility('password')"
					[disabled]="isSubmitting"
					[attr.aria-label]="passwordType === 'password' ? 'Show new password' : 'Hide new password'"
				>
					<mat-icon>{{ passwordType === 'password' ? 'visibility_off' : 'visibility' }}</mat-icon>
				</button>
			</div>
			<p id="adminPasswordHint" class="field-hint">Use between 8 and 128 characters.</p>
			<p class="error" *ngIf="controlHasError('password', 'required')">Password is required.</p>
			<p class="error" *ngIf="controlHasError('password', 'minlength')">Password must be at least 8 characters.</p>
			<p class="error" *ngIf="controlHasError('password', 'maxlength')">Password cannot exceed 128 characters.</p>
		</div>

		<div class="input-box">
			<label for="adminConfirmPassword">Confirm password <span>*</span></label>
			<div class="password-input">
				<input
					id="adminConfirmPassword"
					[type]="confirmPasswordType"
					formControlName="confirmPassword"
					autocomplete="new-password"
				/>
				<button
					type="button"
					mat-icon-button
					(click)="toggleVisibility('confirmPassword')"
					[disabled]="isSubmitting"
					[attr.aria-label]="confirmPasswordType === 'password' ? 'Show confirm password' : 'Hide confirm password'"
				>
					<mat-icon>{{ confirmPasswordType === 'password' ? 'visibility_off' : 'visibility' }}</mat-icon>
				</button>
			</div>
			<p class="error" *ngIf="controlHasError('confirmPassword', 'required')">Confirm password is required.</p>
		</div>

		<p class="error" *ngIf="passwordForm.touched && passwordForm.hasError('passwordMismatch')">
			Password and confirm password must match.
		</p>

		<section class="force-change-card" [class.force-enabled]="forcePasswordChange">
			<mat-checkbox formControlName="forcePasswordChange" color="primary">
				Require user to change password at next login
			</mat-checkbox>
			<p *ngIf="forcePasswordChange">
				The user will only be able to change their password or log out after signing in.
			</p>
			<p *ngIf="!forcePasswordChange">
				The user can continue using this password after signing in.
			</p>
		</section>

		<p class="error server-error" role="alert" aria-live="polite" *ngIf="errorMessage">
			{{ errorMessage }}
		</p>
	</mat-dialog-content>

	<mat-dialog-actions class="dialog-actions">
		<button type="button" mat-stroked-button (click)="cancel()" [disabled]="isSubmitting">Cancel</button>
		<button type="submit" mat-raised-button class="submit-button" [disabled]="passwordForm.invalid || isSubmitting">
			<span>{{ isSubmitting ? 'Changing...' : 'Change Password' }}</span>
		</button>
	</mat-dialog-actions>
</form>
